export const GET_PLANS_DETAILS = '[subscription] Get subscription plans details' as const;
export const SET_IS_LOADING = '[subscription] set all plans loading' as const;
export const SET_SUBSCRIPTION_PLAN = '[subscription] selected plans' as const;